import React, { Component } from "react";
import { Button } from "react-bootstrap";

// Components
import Icon from "../../Icon";
import color from "../../../assets/color";

class Step4 extends Component {
  render() {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center flex-grow-1">
        <Icon type="custom" name="success" color={color.pistachio} size={70} />
        <h1>Success</h1>
        <p className="text-center">
          Login password has been reset successfully.
        </p>
        <Button
          className="mt-2"
          variant="primary"
          onClick={this.props.goToLogin}
        >
          Login Now
        </Button>
      </div>
    );
  }
}

Step4.propTypes = {};

export default Step4;
